import React from 'react';
import { Button, Result, } from 'antd';
import { Link } from 'react-router-dom';
import { HomeOutlined } from '@ant-design/icons';


const NotFound: React.FC = () => (
    <Result
        status="404"
        title="404"
        subTitle="Lo sentimos, la página a la que intenta acceder no existe"
        extra={
            <Button type="primary">
                <Link to="/">
                    <HomeOutlined /> Regresar al inicio
                </Link>
            </Button>
        }
    />
);

export default NotFound;